import modalStyle from "../../modal.module.scss";

import icon_snmp from "assets/images/icons/icn_Info_solid.svg";

import { ReactComponent as ShowIcon } from "assets/images/icons/icn_input_show_hover.svg";
import { ReactComponent as HideIcon } from "assets/images/icons/icn_input_hide.svg";

import React, { useState, useEffect } from 'react';
import { Box, Select, TextField, MenuItem, InputAdornment, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";

import { getDefaultSelectProp, getDefaultTextFieldProp } from "../../../theme";
import { scopeLevelOption } from "../../../const";

const SiteSetting = (props) => {
  const {
    adoptionSource,
    scopeLevel,
    hasSshDevices, sshAccount, setSshAccount, sshPassword, setSshPassword, setSshStatus,
    currentStep, totalSteps, sites, selectedSite, setSelectedSite,
  } = props;

  // State
  const [siteOptions, setSiteOptions] = useState([]);
  const [showEye, setShowEye] = useState(false);

  // Method
  const getSiteId = () => {
    const site = siteOptions.find((site) => site.selected);
    return site ? site.id : "Inventory";
  }

  // Side effect
  useEffect(() => {
    const updatedSiteOptions = [];
    const activeSiteId = selectedSite ? selectedSite.id : "none";

    updatedSiteOptions.push({
      id: "none",
      label: "Select site",
      selected: activeSiteId === "none",
    });

    sites.forEach((site) => {
      const updatedSite = {
        id: site.id,
        label: site.name,
        selected: activeSiteId === site.id,
      };
      updatedSiteOptions.push(updatedSite);
    });

    // Add inventory option
    updatedSiteOptions.push({
      id: "inventory",
      label: <FormattedMessage id="inventory" defaultMessage="Inventory" />,
      selected: activeSiteId === "inventory",
    });

    setSiteOptions(updatedSiteOptions);

    if (!selectedSite) {
      setSelectedSite(updatedSiteOptions[0]);
    }
  }, [sites, selectedSite, setSelectedSite]);

  useEffect(() => {
    setSshStatus(!hasSshDevices || (sshAccount.length > 0 && sshPassword.length > 0));
  }, [sshAccount, sshPassword, hasSshDevices]);

  if (currentStep === totalSteps) {
    return null;
  }

  return (
    <>
      {
        hasSshDevices && (
          <Box>
            <Box display="flex" alignItems="center">
              <img src={icon_snmp} alt="" style={{ marginRight: '10px' }} />
              <Typography color="#707ca8" fontWeight="600" fontSize="20px">
                SSH Authentication
              </Typography>
            </Box>
            <Box style={{ marginLeft: "25px", marginBottom: '20px' }}>
              Please enter valid SSH credentials.
            </Box>
            <Box
              className={modalStyle['field-container']}
              style={{ gridTemplateColumns: '190px 1fr', marginLeft: "25px", marginBottom: '10px' }}
            >
              <Box style={{ marginRight: '30px' }}
              >
                SSH Username
              </Box>
              <Box className={modalStyle['item']}>
                <Box style={{ width: '300px' }}>
                  <TextField
                    fullWidth
                    placeholder=""
                    type="text"
                    value={sshAccount}
                    autoComplete="new-password"
                    onChange={(e) => setSshAccount(e.target.value)}
                    sx={{ ...getDefaultTextFieldProp().sx }}
                  />
                </Box>
              </Box>
            </Box>
            <Box className={modalStyle['field-container']} style={{ gridTemplateColumns: '190px 1fr', marginLeft: "25px" }} >
              <Box style={{ marginRight: '30px' }}>
                SSH Password
              </Box>
              <Box className={modalStyle['item']}>
                <Box className={modalStyle['container']} style={{ width: '300px' }}>
                  <TextField
                    fullWidth
                    placeholder=""
                    type={showEye ? 'text' : 'password'}
                    value={sshPassword}
                    autoComplete="new-password"
                    onChange={(e) => setSshPassword(e.target.value)}
                    sx={{ ...getDefaultTextFieldProp().sx }}
                    InputProps={{
                      endAdornment: showEye ? (
                        <InputAdornment position="end">
                          <ShowIcon onClick={() => setShowEye(!showEye)} style={{ cursor: 'pointer' }} />
                        </InputAdornment>
                      ) : (
                        <InputAdornment position="end">
                          <HideIcon onClick={() => setShowEye(!showEye)} style={{ cursor: 'pointer' }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>
              </Box>
            </Box>
            <hr style={{ marginTop: '20px' }} />
          </Box>
        )
      }
      {
        scopeLevel === scopeLevelOption.org && (
          <>
            <Box style={{ padding: "10px 20px", textAlign: 'center' }}>
              Please ensure the devices' IP settings allow them to reach the controller before proceeding. Incorrect IP settings may prevent the devices from being adopted successfully.
            </Box>
            <Box
              display="flex"
              flexDirection="row"
              justifyContent="center"
              alignItems="center"
              style={{ margin: '20px 20px 30px 20px' }}
            >
              <Box className={`${modalStyle['field']}}`} style={{ marginRight: '30px' }} >
                Add to site
              </Box>
              <Box className={modalStyle['item']}>
                <Box className={modalStyle['container']} >
                  <Select
                    style={{ ...getDefaultSelectProp().style, width: '210px' }}
                    value={getSiteId()}
                    onChange={(e) => {
                      const updatedSiteOptions = siteOptions.map((site) => {
                        if (site.id === e.target.value) {
                          return { ...site, selected: true };
                        }
                        return { ...site, selected: false };
                      });
                      setSiteOptions(updatedSiteOptions);
                      setSelectedSite(updatedSiteOptions.find((site) => site.selected));
                    }}
                    sx={{ ...getDefaultSelectProp().sx, width: "300px" }}
                    MenuProps={{ ...getDefaultSelectProp().menuProps }}
                  >
                    {Object.values(siteOptions).map((site, index) => {
                      if (site.id === "inventory") {
                        return null;
                      }

                      return (
                        <MenuItem value={site.id} key={`${index}-${site.id}-site`}>{site.label}</MenuItem>
                      );
                    })}
                    <hr style={{ width: '80%' }} />
                    <MenuItem value={"inventory"} key={`inventory-site`}>Inventory</MenuItem>
                  </Select>
                </Box>
              </Box>
            </Box >
          </>
        )
      }
    </>
  );
}

export default SiteSetting;